<template>
    <div class="prefix-item-container">
        <div
            class="prefix-item"
            :data-level="prefix.level"
            :data-parent="prefix.parent"
            :data-id="prefix.ID"
            @dragstart="onDragStart"
            @dragend="onDragEnd"
            @drop="onDrop"
            @dragover="allowDrop"
            @dragenter="addDragClass"
            @dragleave="removeDragClass"
        >
            <template v-if="prefix.editing">
                <ui5-input
                    :type="prefix.level == 1 ? 'Text' : 'Number'"
                    :value="prefix.value"
                    @input="prefix.value = $event.target.value"
                    placeholder="waarde"
                    @keyup.enter="update"
                />
                <ui5-input
                    :value="prefix.label"
                    @input="prefix.label = $event.target.value"
                    placeholder="label"
                    @keyup.enter="update"
                />
                <ui5-button @click="update">Opslaan</ui5-button>
            </template>
            <template v-else>
                <span>{{ prefix.value }} - {{ prefix.label }}</span>
                <span v-if="isDebug">
                    - {{ prefix.level }} #{{ prefix.ID }}
                </span>
                <i
                    class="fa fa-pencil"
                    @click="openEditing(prefix)"
                />
                <i
                    class="fa fa-plus"
                    @click="
                        createPrefix({
                            parent: prefix.ID,
                            level: parseInt(prefix.level) + 1,
                        })
                    "
                    v-if="prefix.level < 3"
                />
                <i
                    class="fa fa-trash"
                    @click="promptRemove"
                    v-if="prefix.ID"
                />
                <i
                    class="fa fa-bars drag-handle"
                    v-if="prefix.level > 1"
                    @mousedown="handleMouseDown"
                    @mouseup="handleMouseUp"
                />
            </template>
            <spinner v-if="saving" />
            <div
                class="error"
                v-if="error"
            >
                {{ error }}
            </div>
        </div>
        <ui5-dialog
            class="confirm-remove-dialog"
            ref="confirmRemoveDialog"
            header-text="Prefix verwijderen"
        >
            <div class="dialog-contents">
                <div>
                    Bent u zeker dat u
                    <span>{{ prefix.value }} - {{ prefix.label }}</span>
                    <span v-if="isDebug">
                        - {{ prefix.level }} #{{ prefix.ID }}
                    </span>
                    wilt verwijderen?
                </div>
                <div class="buttons">
                    <ui5-button @click="closeRemoveDialog">
                        Annuleren
                    </ui5-button>
                    <ui5-button @click="remove">Ja</ui5-button>
                </div>
            </div>
        </ui5-dialog>
        <div class="level">
            <prefix-item
                v-for="child in children"
                :add-drag-class="addDragClass"
                :remove-drag-class="removeDragClass"
                :key="child.ID"
                :on-drop="onDrop"
                :prefix="child"
            />
        </div>
    </div>
</template>

<script>
import prefixApi from '../../api/prefix';
import ErrorHelper from '../../helpers/ErrorHelper';
import Spinner from '../loader/Spinner';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import IsDebugMixin from '../../mixins/is-debug';

export default {
    name: 'prefix-item',
    components: { Spinner },
    mixins: [IsDebugMixin],
    props: ['prefix', 'addDragClass', 'removeDragClass', 'onDrop'],
    computed: {
        ...mapGetters({
            getLevel: 'articles/getLevel',
            getFreePrefixes: 'articles/getFreePrefixes',
            getChildren: 'articles/getChildren',
        }),
        children() {
            return this.getChildren(this.prefix.ID);
        },
    },
    data() {
        return {
            error: null,
            saving: false,
        };
    },
    methods: {
        ...mapActions({
            createPrefix: 'articles/createPrefix',
            removePrefixById: 'articles/removePrefixById',
        }),
        ...mapMutations({
            openEditing: 'articles/openEditing',
        }),
        closeRemoveDialog() {
            this.$refs.confirmRemoveDialog.close();
        },
        remove() {
            this.removePrefixById(this.prefix.ID);
            this.closeRemoveDialog();
        },
        promptRemove() {
            const dialog = this.$refs.confirmRemoveDialog;
            dialog.show();
        },
        allowDrop(e) {
            e.preventDefault();
        },
        onDragStart(e) {
            e.target.classList.add('dragged');
            e.dataTransfer.setData('text/plain', this.prefix.ID);
        },
        onDragEnd(e) {
            e.target.classList.remove('dragged');
        },
        handleMouseDown(e) {
            this.$el
                .querySelector('.prefix-item')
                .setAttribute('draggable', 'true');
        },
        handleMouseUp() {
            this.$el
                .querySelector('.prefix-item')
                .setAttribute('draggable', 'false');
        },
        update() {
            const prefixValue = this.prefix.value.toString();
            if (!this.prefix.label || !prefixValue) {
                this.error = 'Beide velden zijn verplicht';
                return;
            }

            const prefixLevel = parseInt(this.prefix.level);
            if (prefixLevel == 1) {
                const onlyLetters = prefixValue.match(/^[A-Z]+$/);
                if (prefixValue.length != 2 || !onlyLetters) {
                    this.error =
                        'Waarde moet bestaan uit exact twee grootletters';
                    return;
                }
            } else {
                if (prefixValue.length != 1) {
                    this.error = 'Waarde moet bestaan uit één cijfer';
                    return;
                }
            }
            this.error = null;
            this.saving = true;
            this.prefix.editing = false;

            prefixApi
                .updatePrefix(this.prefix)
                .catch((error) => {
                    this.error = ErrorHelper.parseError(error.response.data);
                    this.prefix.editing = true;
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
